import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'

export default function ActivityMapMobileLoadingState({
  title = 'Preparando mapa',
  description = 'Estamos cargando la vista interactiva con la ubicación capturada.'
}) {
  return (
    <Box className="activity-map-mobile-loading-shell">
      <Box className="activity-map-mobile-loading-copy">
        <Typography className="activity-map-mobile-loading-title">{title}</Typography>
        <Typography className="activity-map-mobile-loading-text">{description}</Typography>
      </Box>
      <Skeleton
        variant="rounded"
        animation="wave"
        width="100%"
        height="100%"
        sx={{
          borderRadius: '22px',
          bgcolor: 'rgba(0, 0, 0, 0.06)',
          transform: 'none'
        }}
      />
    </Box>
  )
}
